var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-container"},[_c('SVGIcon',{attrs:{"icon":_vm.icon}}),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.placeholder))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }